export default "__VITE_ASSET__C4$jgyDL__"